// extracted by mini-css-extract-plugin
export default {"title":"appTitle_title__PPZGe","white":"appTitle_white__VZGqM","default":"appTitle_default__zUfq1"};